import ClockIndicator from '@/domain/scene/indicators/generic/ClockIndicator.js'

const NAME = 'TrainRightIndicator'
const INIT_X_REL = 0.125
const INIT_Y_REL = 0.388
const CLOCK_POS = 50
const CLOCK_PARENT = 'train'

export default class TrainRightIndicator extends ClockIndicator {
  constructor () {
    super(
      NAME,
      INIT_X_REL,
      INIT_Y_REL,
      CLOCK_POS,
      CLOCK_PARENT
    )
  }
}
